import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';

import { AppContext } from '@prisjakt/ui-app-context';

import actions from '../../../../components/modal/actions';
import ConfirmDialog from '../../../../components/modal/confirm-dialog';

import * as S from './styles';

type Props = {
  id?: string;
  title?: string;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  isOpen: boolean;
  showCancel?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  withOverlay: boolean;
  hideModal: () => void;
  onConfirm: ((input: string) => void) | null;
  onCancel: (input: string) => void;
  cancelColor?: string;
  confirmColor?: string;
};

type State = {
  input: string | null;
  warning: boolean;
};

const SettingsDialog = (props: Props) => {
  const { t } = useContext(AppContext);
  const [input, setInputState] = useState<State['input']>(null);
  const [warning, setWarningState] = useState<State['warning']>(false);

  const confirm = () => {
    if (!input) {
      setWarningState(true);
    } else if (props.onConfirm) props.onConfirm(input);
  };

  return (
    <ConfirmDialog
      id={props.id}
      isOpen={props.isOpen}
      title={props.title}
      showCancel={props.showCancel}
      confirmLabel={props.confirmLabel}
      cancelLabel={props.cancelLabel}
      cancelColor={props.cancelColor}
      confirmColor={props.confirmColor}
      onConfirm={() => {
        confirm();
      }}
      onCancel={props.onCancel}
    >
      <S.TextInput
        name="promptInput"
        autoFocus
        type="text"
        label={props.label}
        placeholder={props.placeholder}
        warning={warning}
        helper={warning ? t('errors', 'prompt.field-is-required') : undefined}
        defaultValue={props.defaultValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setInputState(e.target.value);
          setWarningState(false);
        }}
        onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) =>
          e.key === 'Enter' ? confirm() : null
        }
      />
    </ConfirmDialog>
  );
};

SettingsDialog.defaultProps = {
  placeholder: '',
  defaultValue: '',
  isOpen: false,
  showCancel: false,
  withOverlay: false,
};

export default connect(
  null,
  actions
)(SettingsDialog);
